import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShoppingCart, Plus, Check } from "lucide-react";
import api from "@/lib/api";
import { SHOP_CATEGORIES } from "@/lib/labels";

export default function SharedShopping() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [name, setName] = useState("");
  const [qty, setQty] = useState("");
  const [error, setError] = useState(false);
  const load = () => api.get(`/shopping/shared/${token}`).then((r) => setData(r.data)).catch(() => setError(true));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [token]);
  const toggle = (id) => api.post(`/shopping/shared/${token}/toggle`, { item_id: id }).then(load);
  const add = async (e) => { e.preventDefault(); if (!name.trim()) return; await api.post(`/shopping/shared/${token}/add`, { name: name.trim(), quantity: qty.trim() }); setName(""); setQty(""); load(); };

  if (error) return <div className="min-h-screen bg-brand-cream flex items-center justify-center p-6"><p className="font-head font-black text-xl text-brand-ink">Deze lijst bestaat niet (meer).</p></div>;
  if (!data) return <div className="min-h-screen bg-brand-cream flex items-center justify-center"><p className="font-bold text-brand-ink/60">Laden…</p></div>;

  const items = data.items || [];
  const active = items.filter((i) => !i.checked);
  const done = items.filter((i) => i.checked);
  const row = (it) => (
    <div key={it.id} data-testid={`shared-item-${it.id}`} className={`brutal-sm rounded-xl px-3 py-3 bg-white flex items-center gap-3 ${it.checked ? "opacity-50" : ""}`}>
      <button data-testid={`shared-toggle-${it.id}`} onClick={() => toggle(it.id)} className={`w-7 h-7 rounded-md border-2 border-brand-ink flex items-center justify-center shrink-0 ${it.checked ? "bg-brand-green" : "bg-white"}`}>{it.checked && <Check className="w-4 h-4" strokeWidth={3} />}</button>
      <div className="flex-1 min-w-0">
        <p className={`font-bold ${it.checked ? "line-through" : ""}`}>{it.name}{it.quantity ? ` (${it.quantity})` : ""}</p>
        {it.added_by_name && <p className="text-xs text-brand-ink/50">door {it.added_by_name}</p>}
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-brand-cream">
      <div className="max-w-md mx-auto p-4 pb-24">
        <div className="flex items-center gap-2 mb-4 pt-2">
          <div className="brutal rounded-2xl bg-brand-green p-2.5"><ShoppingCart className="w-6 h-6 text-brand-ink" strokeWidth={2.5} /></div>
          <div>
            <h1 className="font-head font-black text-2xl leading-none text-brand-ink">Boodschappenlijst</h1>
            {data.org_name && <p className="text-sm font-semibold text-brand-ink/60">{data.org_name}</p>}
          </div>
        </div>

        <form onSubmit={add} className="flex gap-2 mb-4 sticky top-2 z-10">
          <input data-testid="shared-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Voeg item toe…" className="flex-1 min-w-0 brutal-sm rounded-xl px-4 py-3 font-medium outline-none bg-white" />
          <input data-testid="shared-qty" value={qty} onChange={(e) => setQty(e.target.value)} placeholder="Aantal" className="w-20 shrink-0 brutal-sm rounded-xl px-3 py-3 font-medium outline-none bg-white" />
          <button data-testid="shared-add" type="submit" className="brutal brutal-press rounded-xl bg-brand-green px-4 text-brand-ink font-black"><Plus className="w-5 h-5" strokeWidth={3} /></button>
        </form>

        <div className="space-y-4">
          {active.length === 0 && done.length === 0 && <p className="text-center text-brand-ink/50 font-semibold py-8">De lijst is leeg.</p>}
          {SHOP_CATEGORIES.map((cat) => {
            const list = active.filter((i) => (i.category || "Overig") === cat);
            if (!list.length) return null;
            return (
              <div key={cat}>
                <p className="font-head font-bold text-xs text-brand-ink/50 mb-1.5 uppercase tracking-wide">{cat}</p>
                <div className="space-y-2">{list.map(row)}</div>
              </div>
            );
          })}
          {done.length > 0 && (
            <div>
              <p className="font-head font-bold text-xs text-brand-ink/40 mb-1.5 uppercase tracking-wide">Afgevinkt</p>
              <div className="space-y-2">{done.map(row)}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
